import type { Call } from "../types";

/** talk time as mm:ss («01:15»); longer calls keep counting minutes («75:03») */
export const formatDuration = (seconds?: number | null): string => {
  if (seconds == null || !Number.isFinite(seconds) || seconds < 0) return "";
  const s = Math.round(seconds);
  return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
};

/** the record link if it is a web link (http or https), else null */
export const playableUrl = (url?: string | null): string | null => {
  if (typeof url !== "string" || !/^https?:\/\//i.test(url.trim())) return null;
  try {
    const parsed = new URL(url.trim());
    return parsed.protocol === "http:" || parsed.protocol === "https:"
      ? parsed.href
      : null;
  } catch {
    return null;
  }
};

/** what the direction icon says: in, out or missed (an inbound call nobody answered) */
export const callKind = (call: Pick<Call, "direction" | "status">) =>
  call.direction === "out"
    ? "outgoing"
    : call.status === "success" || call.status === "in_progress"
      ? "incoming"
      : "missed";
